const RewardsConfig = bundles.rewardsconfig.jsons.rewardsconfig_json.getJson();
